export const EMAIL_NOT_VERIFIED_ERROR_MESSAGE = 'Not verified.';
